/* eslint-disable no-else-return */
import React from 'react';
import styled from 'styled-components';
import {
  COLOR_ERROR,
  COLOR_PENDING,
  COLOR_SUCCESSFUL,
  EASYPAY_PAYMENT_STATUSES_FORMAT,
  EASYPAY_PAYMENT_TYPES_FORMAT,
  FLOORING_FORM_COMPANIES_NAMES,
  PAYMENT_METHODS,
  PAYMENT_METHODS_STATUSES,
  VEHICLE_STATUSES
} from '../../../../constants';
import { EasyPayStatus } from '../../../../components/EasyPay';
import { Vehicle } from 'types/vehicle';
import { formatCurrency } from 'utils';

const StyledStatus = styled.span`
  color: ${props => props.statusColor || '#000'};
  font-size: 14px;
  min-width: fit-content;
`;

const statusText = {
  awarded: 'Awarded',
  pulled: 'Pulled',
  active: 'Active',
  draft: 'Draft',
  deactivated: 'Deactivated',
  under_review: 'Under Review'
};

const statusColor = {
  awarded: '#009F0F',
  active: '#009F0F',
  pulled: '#E47E00',
  under_review: '#E47E00',
  draft: '#E47E00',
  deactivated: '#E47E00',
  fee_not_charged: '#E47E00'
};

const EASYPAY_PAYMENT_STATUS_COLORS = {
  [PAYMENT_METHODS_STATUSES.APPROVED]: COLOR_SUCCESSFUL,
  [PAYMENT_METHODS_STATUSES.PENDING]: COLOR_PENDING,
  [PAYMENT_METHODS_STATUSES.DECLINED]: COLOR_ERROR
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 60px;
  min-width: 120px;
  justify-content: center;
  border-right: 1px solid #00000033;
  padding-right: 4px;
`;

export const BidStatus = ({ vehicle }: { vehicle: Vehicle }) => {
  const status = vehicle.status;
  const easyPaid = vehicle.payment_method === PAYMENT_METHODS.EASY_PAY;
  const awarded = status === VEHICLE_STATUSES.AWARDED;
  const feeCharged = vehicle.charge_completed;

  const statusRecords = (() => {
    const data: Array<{ label: string; color: string }> = [];
    data.push({ label: statusText[vehicle.status], color: statusColor[vehicle.status] });
    if (awarded) {
      data.push({ label: `(${formatCurrency(vehicle.vehicle_price)})`, color: '#999999' });
      if (!feeCharged) {
        data.push({ label: `(Fee not charged)`, color: statusColor.fee_not_charged });
      }

      if (easyPaid) {
        let paymentType = EASYPAY_PAYMENT_TYPES_FORMAT[vehicle.payment_type] || 'N/A';
        const paymentDescriptionColor = EASYPAY_PAYMENT_STATUS_COLORS[vehicle.payment_status];
        const paymentStatus =
          vehicle.payment_status !== PAYMENT_METHODS_STATUSES.APPROVED
            ? EASYPAY_PAYMENT_STATUSES_FORMAT[vehicle.payment_status]
            : null;

        if (vehicle.payment_status !== PAYMENT_METHODS_STATUSES.DECLINED) {
          const paymentCompany = vehicle.payment_company
            ? `(${FLOORING_FORM_COMPANIES_NAMES[vehicle.payment_company]})`
            : '';
          paymentType = `${paymentType} ${paymentCompany}`;
        }

        const pendingApproval = vehicle.buy_fee && vehicle.buy_fee.pending_bank_flooring_approval;
        if (pendingApproval) {
          data.push({ label: paymentType, color: COLOR_ERROR });
          data.push({ label: 'Pending Bank/Flooring Approval', color: COLOR_ERROR });
        } else {
          const parsed = paymentStatus ? `${paymentType} - ${paymentStatus}` : paymentType;
          data.push({ label: parsed, color: paymentDescriptionColor });
        }
      }
    }
    return data;
  })();

  return (
    <Wrapper>
      {statusRecords.map(rec => (
        <StyledStatus statusColor={rec.color} key={rec.label}>
          {rec.label}
        </StyledStatus>
      ))}
    </Wrapper>
  );
};

export default BidStatus;
